<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="24" height="23" rx="11.5" fill="#F1F8FF" />
    <path
      d="M8.55133 7.8668C8.43133 8.05674 8.27121 8.21813 8.08222 8.33963C7.89324 8.46113 7.67995 8.5398 7.45733 8.57014C7.204 8.60614 6.95267 8.6448 6.70133 8.6868C5.99933 8.80347 5.5 9.42147 5.5 10.1328V15.7501C5.5 16.148 5.65804 16.5295 5.93934 16.8108C6.22064 17.0921 6.60218 17.2501 7 17.2501H17C17.3978 17.2501 17.7794 17.0921 18.0607 16.8108C18.342 16.5295 18.5 16.148 18.5 15.7501V10.1328C18.5 9.42147 18 8.80347 17.2987 8.6868C17.0471 8.6449 16.7951 8.606 16.5427 8.57014C16.3202 8.53971 16.107 8.46099 15.9181 8.33949C15.7293 8.218 15.5693 8.05667 15.4493 7.8668L14.9013 6.98947C14.7783 6.78954 14.6088 6.6222 14.4074 6.50163C14.2059 6.38106 13.9784 6.3108 13.744 6.2968C12.5822 6.2344 11.4178 6.2344 10.256 6.2968C10.0216 6.3108 9.7941 6.38106 9.59264 6.50163C9.39118 6.6222 9.22174 6.78954 9.09867 6.98947L8.55133 7.8668V7.8668Z"
      stroke="#417CE9"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 12.25C15 13.0456 14.6839 13.8087 14.1213 14.3713C13.5587 14.9339 12.7956 15.25 12 15.25C11.2044 15.25 10.4413 14.9339 9.87868 14.3713C9.31607 13.8087 9 13.0456 9 12.25C9 11.4544 9.31607 10.6913 9.87868 10.1287C10.4413 9.56607 11.2044 9.25 12 9.25C12.7956 9.25 13.5587 9.56607 14.1213 10.1287C14.6839 10.6913 15 11.4544 15 12.25V12.25ZM16.5 10.75H16.5053V10.7553H16.5V10.75Z"
      stroke="#417CE9"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
